export const LikeComment = ({ width = '16', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 16C1.34315 16 0 14.6569 0 13V9C0 7.34315 1.34315 6 3 6H4.352L5.55279 1.65836C6.03107 0.701792 6.97938 0.0768256 8.03664 0.00660995L8.23607 0H8.5C9.82548 0 10.91 1.03154 10.9947 2.33562L11 2.5V6H12.9983C13.1958 6 13.3929 6.01951 13.5866 6.05826C15.1533 6.37159 16.1889 7.85238 15.9696 9.4145L15.94 9.58835L14.74 13.5883C14.4712 14.9322 13.3293 15.9152 11.9759 15.9948L11.7983 16H3ZM4 8H3C2.44772 8 2 8.44771 2 9V13C2 13.5523 2.44772 14 3 14H4V8ZM8.5 2H8.23607C7.9468 2 7.67649 2.12482 7.48944 2.3347L7.41457 2.42975L6.24444 6.6633C6.20996 6.78805 6.16345 6.90916 6.10557 7.02492C6.0535 7.12906 6.02015 7.24123 6.00673 7.35629L6 7.47214V14H11.8583C12.2952 14 12.6765 13.7173 12.809 13.3101L12.8843 13.0137L14.0501 9.12783L14.0584 9.00922C14.0633 8.53817 13.7332 8.11519 13.2544 8.01942L13.1568 8.00487L13.0583 8H11C9.94564 8 9.08183 7.18412 9.00549 6.14926L9 6V2.5C9 2.25454 8.82312 2.05039 8.58988 2.00806L8.5 2Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
